/**
 * ============================================================================
 * USER / TENANT SERVICE: WhatsApp Phone Numbers (`tbl_phone_numbers` - Sheet 16)
 * ============================================================================
 * Purpose:
 *   Handles sending phone numbers provisioned for the active tenant,
 *   Meta WABA IDs, Business Account IDs, Cloud API tokens, and webhook URLs.
 *
 * Database Scope:
 *   Tenant Database (`digi_user_<id>`)
 * ============================================================================
 */

import { createCrudService } from "../../core/services/crudServiceFactory";

const basePhoneNumberService = createCrudService("tenant/phone-numbers");

const phoneNumberService = {
  ...basePhoneNumberService,
  getPhoneNumbers: (params = {}) => basePhoneNumberService.get(params),
};

export default phoneNumberService;
